import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { MAX_NOTIFICATIONS } from "./constants";
import { Notification, NotificationProps } from "./types";

export const notificationsSlice = createSlice({
  name: "notifications",
  initialState: {
    notifications: [] as Notification[],
  },
  reducers: {
    addNotification: (state, action: PayloadAction<NotificationProps>) => {
      const { message, type, duration } = action.payload;

      // Dedup: ignore if an active notification with the same message + type exists
      const isDuplicate = state.notifications.some(
        (notification) =>
          notification.message === message && notification.type === type,
      );
      if (isDuplicate) {
        return;
      }

      // Evict oldest (FIFO) once the queue is full
      if (state.notifications.length >= MAX_NOTIFICATIONS) {
        state.notifications.shift();
      }

      state.notifications.push({
        id: crypto.randomUUID(),
        message,
        type,
        duration,
      });
    },
    removeNotification: (state, action: PayloadAction<string>) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload,
      );
    },
    clearNotification: (state) => {
      state.notifications = [];
    },
  },
});

export const { addNotification, removeNotification, clearNotification } =
  notificationsSlice.actions;
